import React from 'react';
import {SketchfabItem } from './view/sketchfabItem';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'SketchfabItem', 
  itemElt: (item, cmsOption) => <SketchfabItem item={item} cmsOption={cmsOption} />
}